import { AutoMap } from "@automapper/classes";
import { BaseModel } from "../base/base.model";
import { convertUsing, createMap, forMember, mapFrom, mapWith } from '@automapper/core';
import { mapper } from "src/app/infrastructure/infrastructure-services/common/mapper";


export interface IDocumentLinesModel {
    itemCode: string,
    itemDescription: string,
    barCode: string,
    quantity: number,
    measureUnit: string,
    measureUnitName: string,
    price: number,
    lineTotal: number,
    warehouseCode: string,
    warehouseName: string,
    warehouseQuantity: number,
    accountCode: string,
    accountName: string,
    projectCode: string,
    projectName: string,
    activeAccount: string;
    branchname: string;
    bplId: string;
    serialNumbers: ISerialNumbersModel[],
    batchNumbers: BatchNumbersModel[],
    manageBatchNumbers:string;
    manageSerialNumbers:string;

}
export class DocumentLinesModel implements IDocumentLinesModel {
    @AutoMap() itemCode: string = "";
    @AutoMap() itemDescription = "";
    @AutoMap() barCode: string = "";
    @AutoMap() quantity: number = 0;
    @AutoMap() measureUnit: string = "";
    @AutoMap() measureUnitName: string = "";
    @AutoMap() price: number = 0;
    @AutoMap() lineTotal: number = 0;
    @AutoMap() warehouseCode: string = ""
    @AutoMap() warehouseName: string = "";
    @AutoMap() warehouseQuantity: number = 0;
    @AutoMap() accountCode: string = "";
    @AutoMap() accountName: string = "";
    @AutoMap() projectCode: string = "";
    @AutoMap() projectName: string = "";
    @AutoMap() activeAccount: string = "";
    @AutoMap() branchname: string = "";
    @AutoMap() bplId: string = "";
    @AutoMap() serialNumbers: SerialNumbersModel[] = [];
    @AutoMap() batchNumbers: BatchNumbersModel[] = [];
    @AutoMap() manageSerialNumbers :string ="";
    @AutoMap() manageBatchNumbers:string="";

    constructor() {
        createMap(mapper, DocumentLinesModel, DocumentLinesModelSAP,
            forMember(
                (destination) => destination.ItemCode,
                mapFrom((source) => source.itemCode)
            ),
            forMember(
                (destination) => destination.ItemDescription,
                mapFrom((source) => source.itemDescription)
            ),
            forMember(
                (destination) => destination.BarCode,
                mapFrom((source) => source.barCode)
            ),
            forMember(
                (destination) => destination.Quantity,
                mapFrom((source) => source.quantity)
            ),
            // forMember(
            //     (destination) => destination.MeasureUnit,
            //     mapFrom((source) => source.measureUnit)
            // ),
            forMember(
                (destination) => destination.UnitPrice,
                mapFrom((source) => source.price)
            ),
            forMember(
                (destination) => destination.LineTotal,
                mapFrom((source) => source.lineTotal)
            ),
            forMember(
                (destination) => destination.WarehouseCode,
                mapFrom((source) => source.warehouseCode)
            ),
            // forMember(
            //     (destination) => destination.WarehouseName,
            //     mapFrom((source) => source.warehouseName)
            // ),
            forMember(
                (destination) => destination.WarehouseQuantity,
                mapFrom((source) => source.warehouseQuantity)
            ),
            // forMember(
            //     (destination) => destination.AccountCode,
            //     mapFrom((source) => source.accountCode)
            // ),
            forMember(
                (destination) => destination.ProjectCode,
                mapFrom((source) => source.projectCode)
            ),
            forMember(
                (destination) => destination.BatchNumbers,
                mapWith(BatchNumbersModelSAP, BatchNumbersModel, (source) => source.batchNumbers)
           
            ),
            forMember(
                (destination) => destination.SerialNumbers,
                mapWith(SerialNumbersModelSAP, SerialNumbersModel, (source) => source.serialNumbers)
            )
        );
    }
}

export interface IBatchNumbersModel {
    batchNumber: string,
    manufacturerSerialNumber: string| null,
    internalSerialNumber: string | null,
    expiryDate: string,
    manufacturingDate: string,
    addmisionDate: string,
    notes: string,
    quantity: number,
    baseLineNumber: number,
    itemCode: string,
    systemSerialNumber: number
}

export interface ISerialNumbersModel {
    manufacturerSerialNumber: string| null,
    internalSerialNumber: string | null,
    expiryDate: string,
    manufactureDate: string,
    receptionDate: string,
    baseLineNumber: number,
    systemSerialNumber: number,
    quantity: number,
    itemCode: string,
    wareHouseCode: string,
    wareHouseName: string
}
export class BatchNumbersModel implements IBatchNumbersModel {
    @AutoMap() batchNumber: string = "";
    @AutoMap() manufacturerSerialNumber: string| null = null;
    @AutoMap() internalSerialNumber: string |null= null;
    @AutoMap() expiryDate: string = "";
    @AutoMap() manufacturingDate: string = "";
    @AutoMap() addmisionDate: string = "";
    @AutoMap() notes: string = "";
    @AutoMap() quantity: number = 0;
    @AutoMap() baseLineNumber: number = 0;
    @AutoMap() itemCode: string = "";
    @AutoMap() systemSerialNumber: number = 0;
    @AutoMap() batchNumberProperty:string=''

    constructor() {
        createMap(mapper, BatchNumbersModel, BatchNumbersModelSAP,
            forMember(
                (destination) => (destination.BatchNumber),
                mapFrom((source) => (source.batchNumber))
            ),
            forMember(
                (destination) => (destination.ManufacturerSerialNumber),
                mapFrom((source) => (source.manufacturerSerialNumber))
            ),
            forMember(
                (destination) => (destination.BatchNumberProperty),
                mapFrom((source) => (source.batchNumberProperty))
            ),
            forMember(
                (destination) => (destination.InternalSerialNumber),
                mapFrom((source) => (source.internalSerialNumber))
            ),
            forMember(
                (destination) => (destination.ExpiryDate),
                mapFrom((source) => (source.expiryDate))
            ),
            forMember(
                (destination) => (destination.ManufacturingDate),
                mapFrom((source) => (source.manufacturingDate))
            ),
            forMember(
                (destination) => (destination.AddmisionDate),
                mapFrom((source) => (source.addmisionDate))
            ),
            forMember(
                (destination) => (destination.Notes),
                mapFrom((source) => (source.notes))
            ),
            forMember(
                (destination) => (destination.Quantity),
                mapFrom((source) => (source.quantity))
            ),
            // forMember(
            //     (destination) => (destination.BaseLineNumber),
            //     mapFrom((source) => (source.baseLineNumber))
            // ),
            forMember(
                (destination) => (destination.ItemCode),
                mapFrom((source) => (source.itemCode))
            ),
            forMember(
                (destination) => (destination.ItemCode),
                mapFrom((source) => (source.itemCode))
            )
            // forMember(
            //     (destination) => (destination.SystemSerialNumber),
            //     mapFrom((source) => (source.systemSerialNumber))
            // ),

        );
    }
}

export interface IBatchNumbersModelSAP {
    BatchNumber: string,
    ManufacturerSerialNumber: string | null,
    InternalSerialNumber: string | null, 
    ExpiryDate: string,
    ManufacturingDate: string,
    AddmisionDate: string,
    Notes: string,
    Quantity: number,
   // BaseLineNumber: number,
    ItemCode: string,
 // SystemSerialNumber: number
 // SysNumber:string
 BatchNumberProperty:string
                        
}

export class BatchNumbersModelSAP implements IBatchNumbersModelSAP {
    @AutoMap() BatchNumber: string = "";
    @AutoMap() ManufacturerSerialNumber: string | null= null;
    @AutoMap() InternalSerialNumber: string| null = null;
    @AutoMap() ExpiryDate: string = "";
    @AutoMap() ManufacturingDate: string = "";
    @AutoMap() AddmisionDate: string = "";
    @AutoMap() Notes: string = "";
    @AutoMap() Quantity: number = 0;
   // @AutoMap() BaseLineNumber: number = 0;
    @AutoMap() ItemCode: string = "";
 //  @AutoMap() SystemSerialNumber: number = 19;
   //@AutoMap() SystemSerialNumber:   string="abc";
    @AutoMap() BatchNumberProperty:string=''
   // @AutoMap() SysNumber:string="abc";

    constructor() {
        createMap(mapper, BatchNumbersModel, BatchNumbersModelSAP,
            forMember(
                (destination) => (destination.BatchNumber),
                mapFrom((source) => (source.batchNumber))
            ),
            forMember(
                (destination) => (destination.ManufacturerSerialNumber),
                mapFrom((source) => (source.manufacturerSerialNumber))
            ),
            forMember(
                (destination) => (destination.InternalSerialNumber),
                mapFrom((source) => (source.internalSerialNumber))
            ),
            forMember(
                (destination) => (destination.ExpiryDate),
                mapFrom((source) => (source.expiryDate))
            ),
            forMember(
                (destination) => (destination.ManufacturingDate),
                mapFrom((source) => (source.manufacturingDate))
            ),
            forMember(
                (destination) => (destination.AddmisionDate),
                mapFrom((source) => (source.addmisionDate))
            ),
            forMember(
                (destination) => (destination.Notes),
                mapFrom((source) => (source.notes))
            ),
            forMember(
                (destination) => (destination.Quantity),
                mapFrom((source) => (source.quantity))
            ),
            // forMember(
            //     (destination) => (destination.BaseLineNumber),
            //     mapFrom((source) => (source.baseLineNumber))
            // ),
            forMember(
                (destination) => (destination.ItemCode),
                mapFrom((source) => (source.itemCode))
            ),
            forMember(
                (destination) => (destination.ItemCode),
                mapFrom((source) => (source.itemCode))
            ),
            forMember(
                (destination) => (destination.BatchNumberProperty),
                mapFrom((source) => (source.batchNumberProperty))
            ),

            // forMember(
            //     (destination) => (destination.SystemSerialNumber),
            //     mapFrom((source) => (source.systemSerialNumber))
            // ),

        );
    }
}

export class SerialNumbersModel implements ISerialNumbersModel {

    @AutoMap() manufacturerSerialNumber: string|null = null;
    @AutoMap() internalSerialNumber: string | null= null;
    @AutoMap() expiryDate: string = "";
    @AutoMap() manufactureDate: string = "";
    @AutoMap() receptionDate: string = "";
    @AutoMap() baseLineNumber: number = 0;
    @AutoMap() systemSerialNumber: number = 0;
    @AutoMap() quantity: number = 0;
    @AutoMap() itemCode: string = "";
    @AutoMap() wareHouseCode: string = "";
    @AutoMap() wareHouseName: string = "";
    constructor() {
        createMap(mapper ,SerialNumbersModel, SerialNumbersModelSAP,
            forMember(
                (destination) => (destination.ManufacturerSerialNumber),
                mapFrom((source) => (source.manufacturerSerialNumber))
            ),
            forMember(
                (destination) => (destination.InternalSerialNumber),
                mapFrom((source) => (source.internalSerialNumber))
            ),
            forMember(
                (destination) => (destination.ExpiryDate),
                mapFrom((source) => (source.expiryDate))
            ),
            forMember(
                (destination) => (destination.ManufactureDate),
                mapFrom((source) => (source.manufactureDate))
            ),
            forMember(
                (destination) => (destination.ReceptionDate),
                mapFrom((source) => (source.receptionDate))
            ),
            forMember(
                (destination) => (destination.BaseLineNumber),
                mapFrom((source) => (source.baseLineNumber))
            ),
            forMember(
                (destination) => (destination.SystemSerialNumber),
                mapFrom((source) => (source.systemSerialNumber))
            ),
            forMember(
                (destination) => (destination.Quantity),
                mapFrom((source) => (source.quantity))
            ),
            forMember(
                (destination) => (destination.ItemCode),
                mapFrom((source) => (source.itemCode))
            ),
            forMember(
                (destination) => (destination.WareHouseCode),
                mapFrom((source) => (source.wareHouseCode))
            ),
            forMember(
                (destination) => (destination.WareHouseName),
                mapFrom((source) => (source.wareHouseName))
            ),
        );
    }
}

export interface ISerialNumbersModelSAP {
    ManufacturerSerialNumber: string,
    InternalSerialNumber: string,
    ExpiryDate: string,
    ManufactureDate: string,
    ReceptionDate: string,
    BaseLineNumber: number,
    SystemSerialNumber: number,
    Quantity: number,
    ItemCode: string,
    WareHouseCode: string,
    WareHouseName: string

}

export class SerialNumbersModelSAP implements ISerialNumbersModelSAP {
    @AutoMap() ManufacturerSerialNumber: string = "";
    @AutoMap() InternalSerialNumber: string = "";
    @AutoMap() ExpiryDate: string = "";
    @AutoMap() ManufactureDate: string = "";
    @AutoMap() ReceptionDate: string = "";
    @AutoMap() BaseLineNumber: number = 0;
    @AutoMap() SystemSerialNumber: number = 0;
    @AutoMap() Quantity: number = 0;
    @AutoMap() ItemCode: string = "";
    @AutoMap() WareHouseCode: string = "";
    @AutoMap() WareHouseName: string = "";

    constructor() {
        createMap(mapper, SerialNumbersModel, SerialNumbersModelSAP,
            forMember(
                (destination) => (destination.ManufacturerSerialNumber),
                mapFrom((source) => (source.manufacturerSerialNumber))
            ),
            forMember(
                (destination) => (destination.InternalSerialNumber),
                mapFrom((source) => (source.internalSerialNumber))
            ),
            forMember(
                (destination) => (destination.ExpiryDate),
                mapFrom((source) => (source.expiryDate))
            ),
            forMember(
                (destination) => (destination.ManufactureDate),
                mapFrom((source) => (source.manufactureDate))
            ),
            forMember(
                (destination) => (destination.ReceptionDate),
                mapFrom((source) => (source.receptionDate))
            ),
            forMember(
                (destination) => (destination.BaseLineNumber),
                mapFrom((source) => (source.baseLineNumber))
            ),
            forMember(
                (destination) => (destination.SystemSerialNumber),
                mapFrom((source) => (source.systemSerialNumber))
            ),
            forMember(
                (destination) => (destination.Quantity),
                mapFrom((source) => (source.quantity))
            ),
            forMember(
                (destination) => (destination.ItemCode),
                mapFrom((source) => (source.itemCode))
            ),
            forMember(
                (destination) => (destination.WareHouseCode),
                mapFrom((source) => (source.wareHouseCode))
            ),
            forMember(
                (destination) => (destination.WareHouseName),
                mapFrom((source) => (source.wareHouseName))
            ),
        );
    }
}
export interface IDocumentLinesModelSAP {
    ItemCode: string,
    ItemDescription: string,
    BarCode: string,
    Quantity: number,
    //  MeasureUnit: string,
    UnitPrice: number,
    LineTotal: number,
    WarehouseCode: string,
    //WarehouseName: string,
    WarehouseQuantity: number,
    //  AccountCode: string,
    // AccountName:string,
    ProjectCode: string,
    // ProjectName:string
    SerialNumbers: any[],
    BatchNumbers: any[],
}
export class DocumentLinesModelSAP implements IDocumentLinesModelSAP {
    @AutoMap() ItemCode: string = "";
    @AutoMap() ItemDescription: string = "";
    @AutoMap() BarCode: string = "";
    @AutoMap() Quantity: number = 0;
    //  @AutoMap() MeasureUnit: string = "";
    @AutoMap() UnitPrice: number = 0;
    @AutoMap() LineTotal: number = 0;
    @AutoMap() WarehouseCode: string = "";
    // @AutoMap() WarehouseName: string = "";
    @AutoMap() WarehouseQuantity: number = 0;
    //@AutoMap() AccountCode: string = "";
    // @AutoMap() AccountName:string="";
    @AutoMap() ProjectCode: string = "";
    //    @AutoMap() ProjectName:string="";
    @AutoMap() SerialNumbers: SerialNumbersModelSAP[] = [];
    @AutoMap() BatchNumbers: BatchNumbersModelSAP[] = [];
    constructor() {
        createMap(mapper, DocumentLinesModel, DocumentLinesModelSAP,
            forMember(
                (destination) => destination.ItemCode,
                mapFrom((source) => source.itemCode)
            ),
            forMember(
                (destination) => destination.ItemDescription,
                mapFrom((source) => source.itemDescription)
            ),
            forMember(
                (destination) => destination.BarCode,
                mapFrom((source) => source.barCode)
            ),
            forMember(
                (destination) => destination.Quantity,
                mapFrom((source) => source.quantity)
            ),
            // forMember(
            //     (destination) => destination.MeasureUnit,
            //     mapFrom((source) => source.measureUnit)
            // ),
            forMember(
                (destination) => destination.UnitPrice,
                mapFrom((source) => source.price)
            ),
            forMember(
                (destination) => destination.LineTotal,
                mapFrom((source) => source.lineTotal)
            ),
            forMember(
                (destination) => destination.WarehouseCode,
                mapFrom((source) => source.warehouseCode)
            ),
            // forMember(
            //     (destination) => destination.WarehouseName,
            //     mapFrom((source) => source.warehouseName)
            // ),
            forMember(
                (destination) => destination.WarehouseQuantity,
                mapFrom((source) => source.warehouseQuantity)
            ),
            // forMember(
            //     (destination) => destination.AccountCode,
            //     mapFrom((source) => source.accountCode)
            // ),
            forMember(
                (destination) => destination.ProjectCode,
                mapFrom((source) => source.projectCode)
            ),
            forMember(
                (destination) => destination.BatchNumbers,
                mapWith(BatchNumbersModelSAP, BatchNumbersModel, (source) => source.batchNumbers)
           
            ),
            forMember(
                (destination) => destination.SerialNumbers,
                mapWith(SerialNumbersModelSAP, SerialNumbersModel, (source) => source.serialNumbers)
            )
        );
    }
}

//================Main Model==========
export interface IGoodissueModel extends BaseModel {
    docEntry: number,
    bplId: number,
    branchName: string,
    series: string,
    seriesName: string,
    taxDate: string,
    docDate: string,
    docNum: number,
    reference2: string,
    document:string,
    locked:string,
    comments: string
    journalMemo: string
    documentLines: IDocumentLinesModel[];
    totalCount:number;
    Attachments2_Lines: IAttachments2_LinesModel[] 
    attachmentEntry:string|null;
    docTotal : number;
    U_B1User?: string;
}
export class GoodissueModel implements IGoodissueModel {
    @AutoMap() docEntry: number = 0;
    @AutoMap() bplId: number = 0;
    @AutoMap() branchName: string = "";
    @AutoMap() series: string = "";
    @AutoMap() seriesName: string ="";
    @AutoMap() taxDate: string = "";
    @AutoMap() docDate: string = "";
    @AutoMap() docNum: number = 0;
    @AutoMap() docTotal: number = 0;
    @AutoMap() reference2: string = ""
    @AutoMap() document:string="";
    @AutoMap() locked:string="";
    @AutoMap() comments: string = ""
    @AutoMap() journalMemo: string = ""
    @AutoMap() totalCount:number=0;

    // @AutoMap() documentLines:Array<IDocumentLines>=new Array<IDocumentLines>;
    @AutoMap(() => DocumentLinesModel)
    documentLines: DocumentLinesModel[] = [];
    @AutoMap(() => Attachments2_LinesModel)
    Attachments2_Lines: Attachments2_LinesModel[] = [];
    @AutoMap()  attachmentEntry:string|null=null
    @AutoMap() U_B1User?: string = "";

}


export interface IGoodissueModelSAP {
    BPL_IDAssignedToInvoice: number,
    BPLName: string,
    Series: string,
    TaxDate: string,
    DocDate: string,
    DocNum: number,
    DocumentLines: IDocumentLinesModelSAP[],
    Reference2: string,
    Comments: string,
    JournalMemo: string,
    AttachmentEntry:string|null,
    //DocTotal: number,
    U_B1User?: string,
}
export class GoodissueModelSAP implements IGoodissueModelSAP {
    @AutoMap() BPL_IDAssignedToInvoice: number = 0;
    @AutoMap() BPLName: string = "";
    @AutoMap() Series: string= "";
    @AutoMap() TaxDate: string = "";
    @AutoMap() DocDate: string = "";
    @AutoMap() DocNum: number = 0;
    @AutoMap() DocTotal: number = 0;
    @AutoMap() Reference2: string = "";
    @AutoMap() Comments: string = "";
    @AutoMap() JournalMemo: string = "";
    @AutoMap(() => DocumentLinesModelSAP) DocumentLines: DocumentLinesModelSAP[] = [];
    @AutoMap()  AttachmentEntry:string|null=null
    @AutoMap() U_B1User?: string = "";


    constructor() {
        createMap(mapper, GoodissueModel, GoodissueModelSAP,
            forMember(
                (destination) => destination.BPL_IDAssignedToInvoice,
                mapFrom((source) => source.bplId)
            ),
            forMember(
                (destination) => destination.BPLName,
                mapFrom((source) => source.branchName)
            ),
            forMember(
                (destination) => destination.Series,
                mapFrom((source) => source.series)
            ),
            forMember(
                (destination) => destination.TaxDate,
                mapFrom((source) => source.taxDate)
            ),
            forMember(
                (destination) => destination.DocDate,
                mapFrom((source) => source.docDate)
            ),
            forMember(
                (destination) => destination.DocNum,
                mapFrom((source) => source.docNum)
            ),
            forMember(
                (destination) => destination.Reference2,
                mapFrom((source) => source.reference2)
            ),
            forMember(
                (destination) => destination.Comments,
                mapFrom((source) => source.comments)
            ),
            forMember(
                (destination) => destination.JournalMemo,
                mapFrom((source) => source.journalMemo)
            ),
            // forMember(
            //     (destination) => destination.DocTotal,
            //     mapFrom((source) => source.docTotal)
            // ),
            forMember(
                (destination) => destination.DocumentLines,
                mapWith(DocumentLinesModelSAP, DocumentLinesModel, (source) => source.documentLines)
            ),
            forMember(
                (destination) => destination.U_B1User,
                mapFrom((source) => source.U_B1User)
            ),
        );
    }
}

export interface IAttachments2_LinesModel
{
    AbsoluteEntry: number,
    LineNum: number,
    SourcePath: string
    FileName: string
    FileExtension:string
    AttachmentDate: string
}
export class Attachments2_LinesModel implements IAttachments2_LinesModel
{
    AbsoluteEntry!: number
    LineNum!: number
    SourcePath: string=""
    FileName: string=""
    FileExtension:string=""
    AttachmentDate: string=""
}

